module.exports = __webpack_public_path__ + "static/img/chexian.49339c10.jpg";